"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { useEffect, useState } from "react";
import {
  extractRegionFromCurrentSlug,
  vehicleLinkBuilderByReference,
} from "@/components/package-components/utils";
import { PlatformsImage } from "@/components/package-components/non-editable/core";
import { VehicleCardProps } from "../../props";

export default function VehicleFeatured03({
  vehicle,
  idx,
  ...props
}: VehicleCardProps) {
  const [isClient, setIsClient] = useState(false);

  const site = props.data.site;

  const region = extractRegionFromCurrentSlug(props.data.page?.currentSlug);

  const vehicleUrl =
    vehicleLinkBuilderByReference({
      vehicle,
      site: {
        subdomain: site?.subdomain as string,
        customDomain: site?.customDomain ?? "",
        preferences: site?.preferences ?? [],
      },
      region,
    }) ?? "/";

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  return (
    <Link className="relative" href={vehicleUrl} passHref prefetch>
      <motion.span
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className="relative w-full h-80 rounded-lg p-6 flex justify-center flex-col overflow-hidden hover:opacity-75 xl:w-auto min-w-[300px]"
      >
        <motion.span
          aria-hidden="true"
          className="absolute inset-0"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <span className="absolute inset-0">
            <PlatformsImage
              preload={idx < 3}
              src={
                vehicle.images.split(",").length > 0
                  ? vehicle.images.split(",")[0]
                  : "https://sync-platforms.s3.sa-east-1.amazonaws.com/car-no-image.jpg"
              }
              alt={`Imagem do veículo ${vehicle.make} ${vehicle.model} ${vehicle.version} - ${vehicle.id} ${idx}`}
              className="w-full h-full object-center object-cover"
              width={380}
              height={320}
              style={{ objectFit: "cover" }}
              loading={idx < 3 ? "eager" : "lazy"}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black from-10%  to-transparent to-90%" />
          </span>
        </motion.span>
      </motion.span>
      <span className="absolute bottom-2 text-white z-50 ml-5  font-semibold">
        {vehicle.model}
      </span>
    </Link>
  );
}
